import { NgModule } from '@angular/core';
import { MomentModule } from 'ngx-moment';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import { DirectivesModule } from '../../../components/directives.module';
import { WaitlistComponent } from './waitlist.component';

const ROUTES: Routes = [
  { path: '', component: WaitlistComponent, pathMatch: 'full' },
];

@NgModule({ imports: [
  CommonModule,
  FormsModule,
  DirectivesModule,
  MomentModule,
  RouterModule.forChild(ROUTES),
  AgGridAngular,
],
declarations: [WaitlistComponent],
exports: [WaitlistComponent] })
export class WaitlistModule {}
